<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import PostSaleAnalysisPropertyDocuments from './PostSaleAnalysisPropertyDocuments.vue';
import PostSaleAnalysisPartyDocuments from './PostSaleAnalysisPartyDocuments.vue';
import { usePostSaleAnalysisPropertyDocuments } from '../composables/usePostSaleAnalysisPropertyDocuments';

const props = defineProps({
  loading: { type: Boolean, default: false },
  transaction: { type: Object, default: null },
});
const emit = defineEmits(['openDetail']);
const { t } = useI18n();
const propertyDocuments = usePostSaleAnalysisPropertyDocuments({
  id: computed(() => props.transaction?.id),
  t,
  notify: useAlert,
});

onMounted(propertyDocuments.load);
</script>

<template>
  <div v-if="loading" class="grid gap-4 lg:grid-cols-2">
    <div
      v-for="index in 3"
      :key="index"
      class="h-44 animate-pulse rounded-lais bg-white"
    />
  </div>
  <div v-else-if="transaction" class="grid gap-4">
    <PostSaleAnalysisPropertyDocuments
      :documents="propertyDocuments.documents.value"
      :loading="propertyDocuments.loading.value"
      :details-label="t('POST_SALE.TOPICS.ACTIONS.VIEW_PROPERTY_DETAILS')"
      @download="propertyDocuments.download"
      @details="emit('openDetail', 'property')"
    />
    <div class="grid gap-4 lg:grid-cols-2">
      <PostSaleAnalysisPartyDocuments
        :parties="transaction.party_details || []"
        role="vendedor"
        :transaction-id="transaction.id"
        @details="emit('openDetail', 'sellers')"
      />
      <PostSaleAnalysisPartyDocuments
        :parties="transaction.party_details || []"
        role="comprador"
        :transaction-id="transaction.id"
        @details="emit('openDetail', 'buyers')"
      />
    </div>
  </div>
</template>
